module.exports = __webpack_public_path__ + "img/ip7.367a9e46.png";